const desctiptions = Array.from(document.querySelectorAll(".product__description"));

desctiptions.forEach((element) => {
  const productShowMore = element.querySelector(".product-description__show-more");

  if (productShowMore) {
    productShowMore.addEventListener('click', () => {
      const productTextContainer = element.querySelector(".product-description__text");

      if (productShowMore.classList.contains("close")) {
        productTextContainer.classList.remove("close");
        productShowMore.classList.remove("close");
        productTextContainer.classList.add("open");
        productShowMore.classList.add("open");
      } else {
        productTextContainer.classList.remove("open");
        productShowMore.classList.remove("open");
        productTextContainer.classList.add("close");
        productShowMore.classList.add("close");
      }
    })
  }
})
